import React, { useEffect, useRef } from 'react';

interface FormTextareaProps {
  form: any;
  name: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  className?: string;
  rows?: number;
}

export const FormTextarea: React.FC<FormTextareaProps> = ({
  form,
  name,
  label,
  placeholder,
  required = false,
  disabled = false,
  className = '',
  rows = 4,
}) => {

  const textareaRef = useRef<HTMLTextAreaElement | null>(null);
  useEffect(() => {
    const el = textareaRef.current;
    if (!el) return;
    const autosize = () => {
      el.style.height = '52px';
      el.style.height = el.scrollHeight + 'px';
    };
    el.addEventListener('input', autosize);
    autosize();
    return () => {
      el.removeEventListener('input', autosize);
    };
  }, []);

  return (
    <form.Field
      name={name}
      children={(field: any) => {
        const hasError = field.state.meta.errors?.length > 0;
        const errorMessage = field.state.meta.errors?.[0];

        return (
          <div className={`${hasError ? 'form-element error' : 'form-element'} ${className}`}>
            {label && (
              <label htmlFor={name}>
                {`${label}${required ? '*' : ''}`}
              </label>
            )}
            <textarea
              ref={textareaRef}
              id={name}
              name={name}
              value={field.state.value || ''}
              onChange={(e) => field.handleChange(e.target.value)}
              onBlur={field.handleBlur}
              placeholder={placeholder}
              required={required}
              disabled={disabled}
              rows={rows}
              className=""
            />
            {hasError && (
              <div className="error-message">{errorMessage}</div>
            )}
          </div>
        );
      }}
    />
  );
};